import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const PhoneErrorIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "phone-error",
  "PhoneErrorIcon",
  ["black","#D54941","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2.6665 0.666626H12.6665V8.33329C12.199 8.33329 11.7502 8.4135 11.3332 8.5609V1.99996H3.99984V14H9.0292C9.26405 14.5117 9.60371 14.9653 10.0207 15.3333H2.6665V0.666626Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M8.33594 11.3334H7V12.6693H8.33594V11.3334Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M9.66699 12.3333C9.66699 10.6765 11.0101 9.33331 12.667 9.33331C14.3238 9.33331 15.667 10.6765 15.667 12.3333C15.667 13.9902 14.3238 15.3333 12.667 15.3333C11.0101 15.3333 9.66699 13.9902 9.66699 12.3333Z" fill={colorList[1]} fillRule="evenodd" clipRule="evenodd"/><path d="M13.1098 12.831L13.1098 10.3888L12.2231 10.3888L12.2231 12.831L13.1098 12.831Z" fill={colorList[2]}/><path d="M13.1138 13.3887H12.2237V14.2788H13.1138V13.3887Z" fill={colorList[2]}/></g></svg>
);

export default PhoneErrorIcon;
